import { http } from '@/lib/ats-https';

interface PushApplicationToHrisParams {
  application_id?: string;
  [key: string]: unknown;
}

/**
 * HRIS employee-push service.
 *
 * Relocated here from `src/pages/hris/api.ts` so cross-feature consumers
 * (the ATS HRIS-integration component hooks) stop importing into the hris
 * page layer. The original module re-exports this for within-feature callers.
 */
const pushApplicationToHris = async (params: PushApplicationToHrisParams) => {
  const response = await http.post(
    `/ats_applications/${params?.application_id}/hris_employees`,
    params
  );
  return response;
};

export const HRIS_API_SERVICE = {
  pushApplicationToHris,
};
